import { useEffect, useRef, type ReactNode } from "react";

import { cx } from "./cx";

/**
 * A bare modal card on a blurred scrim (Figma "Dismiss sheet", "Assign to teammate"): no header bar, the
 * content brings its own title. Open while mounted; Escape and a click on the scrim close it.
 */
export function Sheet({
  onClose,
  labelledBy,
  className,
  children,
}: {
  onClose: () => void;
  /** The id of the heading inside that names the dialog. */
  labelledBy: string;
  /** Width and radius of the card. */
  className?: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d || d.open) return;
    if (typeof d.showModal === "function") d.showModal();
    else d.setAttribute("open", ""); // environments without <dialog> support
  }, []);
  return (
    <dialog
      ref={ref}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      aria-labelledby={labelledBy}
      className={cx(
        "m-auto w-[calc(100%-2rem)] overflow-y-auto border border-[#e7ded9] bg-white p-0 text-fg backdrop:bg-[#221c19]/30 backdrop:backdrop-blur-[8px]",
        className,
      )}
    >
      {children}
    </dialog>
  );
}
